export function createProviderReviewsState() {
  return {
    reviews: [],
    loading: true,
    replyTarget: null,
    replyContent: "",
    replyMaxLength: 300,
    isEditing: false,
    deletingReviewId: null,
  };
}
